import React, { useState, useContext } from "react";
import { HEADERTEXT_TYPES } from "../functions/postActionTypes";
import { useHistory } from "react-router-dom";
import {
  IonContent,
  IonPage,
  IonLabel,
  IonItem,
  IonAvatar,
  IonList,
  IonSearchbar,
} from "@ionic/react";
import "../theme/AppStyles.css";
import { ProfileContext } from "../context/ProfileContext";
import { WerkerSchedulerHeader } from "../components/WerkHeader";
import "../theme/AppStyles.css";
import { chatFunction } from "../functions/Fx_Chats";

const CreateNewChat: React.FC = () => {
  const { myAssociates, profile } = useContext(ProfileContext);
  const [searchText, setSearchText] = useState("");
  const history = useHistory<any>();

  const searchTextFunction = (typedValue: string) => {
    setSearchText(typedValue);
  };

  const handleAssociateClick = async (assoc: any) => {
    try {
      // console.log("Creating or opening chat with:", assoc);

      const result = await chatFunction(profile, assoc, "DM");
      // console.log(result);
      history.replace({
        pathname: `/Chat/${result}`,
      });
    } catch (error) {
      // console.log(error);
    }
  };


  return (
    <IonPage>
      <WerkerSchedulerHeader title={HEADERTEXT_TYPES.NewMessage} />
      <IonContent>
        <IonSearchbar
          value={searchText}
          onIonChange={(e) => searchTextFunction(e.detail.value!)}
          animated        ></IonSearchbar>
        <IonList>
          {myAssociates
            .filter((assoc: any) => {
              if (searchText === "") {
                return assoc;
              } else if (
                assoc.WerkerFirstName.toLowerCase().includes(
                  searchText.toLowerCase()
                )
              ) {
                return assoc;
              } else if (
                assoc.WerkerLastName.toLowerCase().includes(
                  searchText.toLowerCase()
                )
              ) {
                return assoc;
              } else {
                return false;
              }
            })
            .sort((a: any, b: any) =>
              a.WerkerFirstName.localeCompare(b.WerkerFirstName)
            )
            .map(
              (assoc: any) => (
                <IonItem
                  key={assoc.WerkerUid}
                  onClick={() => handleAssociateClick(assoc)}                >
                  <IonAvatar className="avatario" slot="start">
                    <img src={assoc.WerkerProfilePicURL} alt="" />
                  </IonAvatar>
                  <IonLabel className="labelo">
                    <p>{assoc.WerkerFirstName + " " + assoc.WerkerLastName}</p>
                    <p></p>
                  </IonLabel>
                  <br></br>
                </IonItem>
              )
            )}
        </IonList>
      </IonContent>
      {/* <TabNavigator /> */}
    </IonPage>
  );
};

export default CreateNewChat;
